export default ({ }, inject) => {
  const resizeImage = (url, params) => {
    return url.replace('.s3.amazonaws.com/', '.images.s3.controlpad.cloud/') + '?auto=enhance&' + params
  }
  inject('imgix', resizeImage)
}
